<ng-content select="glxy-empty-state-hero, [glxyEmptyStateHero]"></ng-content>
<div class="glxy-empty-state__content">
  <ng-content select="glxy-empty-state-title, [glxyEmptyStateTitle]"></ng-content>
  <ng-content></ng-content>
</div>
<ng-content select="glxy-empty-state-actions, [glxyEmptyStateActions]"></ng-content>
<ng-content select="glxy-empty-state-footnote, [glxyEmptyStateFootnote]"></ng-content>
